<template>
  <div class="set-end-divider flex items-center gap-3 py-3 my-1">
    <div class="set-end-line flex-1 h-px" :class="lineClass"></div>
    <span
      class="text-xs font-semibold uppercase tracking-wider whitespace-nowrap px-3"
      :class="textClass"
    >
      {{ label }}
    </span>
    <div class="set-end-line flex-1 h-px" :class="lineClass"></div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: "Approximate set end"
  },
  theme: {
    type: String,
    default: "auto"
  }
});

const lineClass = computed(() => {
  if (props.theme === "light") return "set-end-line--light";
  if (props.theme === "dark") return "set-end-line--dark";
  return "set-end-line--auto";
});

const textClass = computed(() => {
  if (props.theme === "light") return "text-teal-600";
  if (props.theme === "dark") return "text-teal-400";
  return "text-teal-600 dark:text-teal-400";
});
</script>

<style scoped>
.set-end-line {
  border-top: 1px solid;
}

.set-end-line--light {
  border-color: rgb(20 184 166); /* teal-500 */
  box-shadow: 0px 0px 8px 3px rgba(20, 184, 166, 0.5);
}

.set-end-line--dark {
  border-color: rgb(45 212 191); /* teal-400 */
  box-shadow: 0px 0px 8px 3px rgba(45, 212, 191, 0.5);
}

.set-end-line--auto {
  border-color: rgb(20 184 166);
  box-shadow: 0px 0px 8px 3px rgba(20, 184, 166, 0.5);
}

:root.dark .set-end-line--auto,
.dark .set-end-line--auto {
  border-color: rgb(45 212 191);
  box-shadow: 0px 0px 8px 3px rgba(45, 212, 191, 0.5);
}
</style>
